import { focusStrokeOuter, focusStrokeThickness } from '@adaptive-web/adaptive-ui/reference';
import { AdaptiveDesignSystem, textFieldAestheticStyles, textFieldStyleModules, textFieldTemplateStyles, composeTextField } from "@adaptive-web/adaptive-web-components";
import { css } from "@microsoft/fast-element";

export const customTextFieldDefinition = composeTextField(AdaptiveDesignSystem, {
  shadowOptions: {
    delegatesFocus: true
  },
  styleModules: textFieldStyleModules,
  styles: [
    textFieldTemplateStyles,
    textFieldAestheticStyles,
    css`
      .root {
        background-color: var(--background-color) !important;
      }

      :host .root {
        max-height: 50px;
      }

      :host .control {
        height: unset !important;
      }

      :host([disabled]) .label,
      :host([disabled]) .control {
        color: var(--text-color) !important;
      }

      :host(:focus-within) .root {
        outline: ${focusStrokeThickness} solid ${focusStrokeOuter};
        outline-offset: 1px;
      }

      :host .control:autofill,
      :host .control:-webkit-autofill,
      :host .control:autofill:focus,
      :host .control:-webkit-autofill:focus,
      :host .control:-internal-autofill-selected {
        -webkit-box-shadow: 0 0 0 1000px var(--background-color) inset !important;
      }
    `
  ]
})